//URLS TO ENDPOINTS WILL BE PLACED HERE

const Urls = (async () => {

    let newUrl = await (async () => {
        const response = await fetch("api/caasconfig/GetBaseUrl", {
            redirect: 'error'
        });

        const json = await response.json();

        return json.data;
    })();

    const baseUrl = newUrl;

    const getProductionRoleByID = (id) => `${baseUrl}roles/GetProductionRoleByID/${id}`;

    const getPermissionGroupsPerRole = (id) => `${baseUrl}pg/GetPermissionGroupsPerRole/${id}`;

    const getPendingRoles = `api/roles/GetPendingRoles`;

    const getRolesForPgApproval = `api/roles/GetRolesForPgApproval`;

    const getRolesByStatus = `api/roles/GetRolesByStatus`;

    const getAllRoles = `api/roles/GetAllRoles`;

    const getApprovedStatusRoles = `api/roles/GetApprovedRoles`;

    const assignPGsToRole = `api/roles/AssignPermissionGroupsToRole`;

    const getAllPeople = `api/people/GetEmployeesForFeService`;

    const getAllOwners = `api/people/GetEmployeesForOwners`;

    const createRole = `${baseUrl}roles/CreateRole`;

    const updateRoleAdditionalApproversCISO = `${baseUrl}roles/updateRoleAdditionalApproversCISO`;

    const updateRoleAdditionalApproversOwner = `${baseUrl}roles/updateRoleAdditionalApproversOwner`;

    const updateRoleAdditionalApproversPgOwner = `${baseUrl}roles/updateRoleAdditionalApproversPgOwner`;

    const getAllPGs = `api/pg/getAllPGs`;

    const assignEmployeesToRole = `${baseUrl}roles/AssignEmployyesToRole`;

    const getAssignedImportantRoles = `api/roles/GetAssignedImportantRoles`;

    const getAssignedRolesForAdditionalApproval = `api/roles/GetRolesforAdditionalApproval`;

    const getProductionRoles = `api/roles/GetProductionRoles`;

    const cisoApproveRole = `${baseUrl}roles/CisoApproveRole`;

    const additionalApproveRole = `${baseUrl}roles/AdditionalApproveRole`;

    const edit = `api/roles/Edit`;

    const removeEmployee = `api/roles/RemoveRoleEmployee`;

    const generateReportsURL = `api/reporting/GenerateIntersectionReport`;

    const getRelatedPermissionGroups = (id) => `api/pg/GetRelatedPGs/${id}`;

    const generateInactiveAccsReportURL = `api/reporting/GenerateInactiveUserAccountsReport`;

    const generateAllUserAccsReportURL = `api/reporting/GenerateAllUserAccountsReport`;

    const generateUsersWithoutRolesReportURL = `api/reporting/GenerateActiveUsersWithoutRolesReport`;

    const generatePgChangePerUserURL = (totalLines) => `api/reporting/GeneratePGsChangePerUserReport/?totalLines=${totalLines}`;

    const generateUnmatchedEmployeesReportsURL = `api/reporting/GenerateUnmatchedEmployeesReport`;

    const generatePasswordNeverExpiresReportURL = `api/reporting/GeneratePeopleAccountsHavingPasswordNeverExpireReport`;

    const generateGCPReportsURL = `api/reporting/GenerateGCPReport`;

    const generatePGsWithoutDescriptionReportURL = `api/reporting/GeneratePGsWithoutDescriptionReport`;

    const getLoggedInUser = `GetLoggedInUser`;

    const logout = `Logout`;

    const updateRoleOwner = `${baseUrl}roles/UpdateRoleOwner`;

    const updatePgOwner = `${baseUrl}pg/UpdatePermissionGroupOwner`;

    const getManagerSystems = (managerId) => `api/QAR/GetManagerSystems${managerId ? "?managerId=" + managerId : ""}`;

    const getManagerEmployeesForQar = (managerId) => `api/QAR/GetManagerEmployeesForQar?managerId=${managerId}`;

    const getMyManagers = (managerId) => `/api/QAR/GetMyManagers?managerId=${managerId}`;

    const getAllSnpManagers = (currentComplianceReviewId) => `api/QAR/GetAllSnpManagers?complianceReviewId=${currentComplianceReviewId}`;

    const getAllActiveSnpEmployees = (currentComplianceReviewId) => `api/QAR/GetAllActiveSnpEmployees?complianceReviewId=${currentComplianceReviewId}`;

    const getAllManagers = () => `api/QAR/GetAllManagers`;

    const saveManagerReview = `api/QAR/SaveManagerReview`;

    const editManagerReview = `api/QAR/EditManagerReview`;

    const getAllSystemsForReview = (complianceReviewId) => `api/QAR/AllSystemsForReview?complianceReviewId=${complianceReviewId}`;

    const sendSOXEmails = `api/reporting/sendEmailsForManagerReviews`;

    const getAllManagersByAccountId = (accountId, complianceReviewId) => `api/QAR/AllManagersByAccountId?accountId=${accountId}&complianceReviewId=${complianceReviewId}`;

    const getEmployeesByManagerReviewId = (reviewId, accountId, complianceReviewId) => `api/QAR/EmployeesByManagerReviewId?reviewId=${reviewId}&accountId=${accountId}&complianceReviewId=${complianceReviewId}`;

    const saveSoxComment = `api/QAR/SaveSoxComment`;

    const saveFeedback = `api/QAR/SaveFeedback`;

    const getAllEmployeesByAccountId = (accountId, complianceReviewId) => `api/QAR/AllEmployeesByAccountId?accountId=${accountId}&complianceReviewId=${complianceReviewId}`;

    const getGroupsByRoleAndAccount = (roleId, accountId) => `api/QAR/GroupsByRoleAndAccount?roleId=${roleId}&accountId=${accountId}`;

    const getAccountsSyncStatus = `api/account/GetAccountsSyncStatus`;

    const getChameleonAdminsEmployeeReviewsPerAccount = (accountId, complianceReviewId) => `api/QAR/GetChameleonAdminsEmployeeReviewsPerAccount?accountId=${accountId}&complianceReviewId=${complianceReviewId}`;

    const getAllFindingsForAllAccounts = (complianceReviewId) => `api/QAR/GetAllFindingsForAllAccounts?complianceReviewId=${complianceReviewId}`;

    const getAllFindingsByAccountId = (accountId, complianceReviewId) => `api/QAR/GetAllFindingsByAccountId?accountId=${accountId}&complianceReviewId=${complianceReviewId}`;

    const getAllDelegatedEmployeesByAccountId = (accountId, complianceReviewId) => `api/QAR/GetAllDelegatedEmployeesByAccountId?accountId=${accountId}&complianceReviewId=${complianceReviewId}`

    const setManagerReviewsAsCompleted = (quarter, year, userId) => `api/QAR/SetManagerReviewsAsCompleted?quarter=${quarter}&quarterYear=${year}&userId=${userId}`;


    const getAllDataCenters = `${baseUrl}ManagerReview/GetAllDataCenters`;

    const delegateEmployeesFromAdminPanel = `api/QAR/delegateEmployeesFromAdminPanel`

    const getUnmatchedAccounts = (snpAccountId) => `api/QAR/GetUnmatchedAccounts?snpAccountId=${snpAccountId}`;

    const getAllUnmatchedAccounts = () => `api/QAR/GetAllUnmatchedAccounts`;

    const getSnpUnmatchedAccounts = (snpAccountId, complianceReviewId) => `api/QAR/GetSnpUnmatchedAccounts?snpAccountId=${snpAccountId}&complianceReviewId=${complianceReviewId}`;

    const setResponsibleManager = `api/QAR/setResponsibleManager`

    const getReviewHistoryByManagerReviewId = (managerReviewId, accountId) => `api/QAR/getManagerReviewHistory?managerReviewId=${managerReviewId}&accountId=${accountId}`;

    const getComplianceReviews = () => `api/QAR/getComplianceReviews`;

    return {
        getProductionRoleByID,
        getPendingRoles,
        getRolesForPgApproval,
        getRolesByStatus,
        getApprovedStatusRoles,
        getAllPeople,
        getAllOwners,
        createRole,
        assignPGsToRole,
        updateRoleAdditionalApproversCISO,
        updateRoleAdditionalApproversOwner,
        updateRoleAdditionalApproversPgOwner,
        getAllPGs,
        assignEmployeesToRole,
        getAssignedImportantRoles,
        getAssignedRolesForAdditionalApproval,
        cisoApproveRole,
        additionalApproveRole,
        getProductionRoles,
        edit,
        removeEmployee,
        generateReportsURL,
        generateInactiveAccsReportURL,
        generateAllUserAccsReportURL,
        generateUsersWithoutRolesReportURL,
        generatePgChangePerUserURL,
        generateUnmatchedEmployeesReportsURL,
        generatePasswordNeverExpiresReportURL,
        generateGCPReportsURL,
        generatePGsWithoutDescriptionReportURL,
        getRelatedPermissionGroups,
        getLoggedInUser,
        logout,
        getAllRoles,
        updateRoleOwner,
        updatePgOwner,
        getPermissionGroupsPerRole,
        getManagerSystems,
        getManagerEmployeesForQar,
        getMyManagers,
        getAllSnpManagers,
        getAllActiveSnpEmployees,
        getAllManagers,
        saveManagerReview,
        editManagerReview,
        getAllSystemsForReview,
        sendSOXEmails,
        getAllManagersByAccountId,
        getEmployeesByManagerReviewId,
        saveSoxComment,
        saveFeedback,
        getAllEmployeesByAccountId,
        getGroupsByRoleAndAccount,
        getAccountsSyncStatus,
        getChameleonAdminsEmployeeReviewsPerAccount,
        getAllFindingsForAllAccounts,
        getAllFindingsByAccountId,
        getAllDelegatedEmployeesByAccountId,
        setManagerReviewsAsCompleted,
        getAllDataCenters,
        delegateEmployeesFromAdminPanel,
        getUnmatchedAccounts,
        getAllUnmatchedAccounts,
        getSnpUnmatchedAccounts,
        setResponsibleManager,
        getReviewHistoryByManagerReviewId,
        getComplianceReviews
    }
})();

export default Urls;